export function Pakt21LogoMark({ className = '' } = {}) {
  return (
    <svg className={`Pakt21Logo-mark ${className}`.trim()} viewBox="64 42 286 282" aria-hidden="true">
      <g transform="translate(101.95094 51.427856)" fill="currentColor">
        <path d="M102.21-1.983a133.197 133.14 0 0 0-3.573.048l.01 28.753a104.4 104.4 0 0 1 3.563-.061 104.4 104.4 0 0 1 66.834 184.603l.014 34.954A133.197 133.14 0 0 0 102.21-1.983ZM87.29-1.145A133.197 133.14 0 0 0-30.987 131.157 133.197 133.14 0 0 0 48.022 252.781l-.052-32.42a104.4 104.4 0 0 1 39.335-192.535Zm68.48 221.916a104.4 104.4 0 0 1-91.999 7.452l.088 30.435a133.197 133.14 0 0 0 91.952-5.618Z" />
        <path d="m58.485 36.472-.122 49.95-40.155 34.584.122 72.597 29.443 39.788-.122-95.185 39.665-34.4-.061-84.595Z" />
        <path d="m125.451 70.873-26.81 23.322.06-.061V41.247l3.428-1.224Z" />
        <path d="M125.268 70.935c.428 15.242 2.815 23.75-11.202 36.36-14.018 12.61-43.95 43.276-43.95 43.276s-5.632 5.632-6.183 18.241c-.55 12.61 0 59.498 0 59.498l30.361-6.366.062-48.724s-.49-3 4.345-6.305c4.836-3.305 64.456-64.395 64.456-64.395s16.711-19.894 15.059-23.567c-1.653-3.672-75.903-38.992-75.964-38.747-.061.245 23.016 30.729 23.016 30.729Z" />
        <path d="m178.155 79.015-44.746-33.973c-26.444-7.59 44.746 33.973 44.746 33.973ZM161.689 81.524l-57.172-39.971 28.892 5.815 26.688 19.404Z" />
        <path d="M185.97 88.55s-6.969 16.578-27.052 32.247l.086 24.584s2.424-.692 10.085-6.102ZM185.926 88.507s10.53 16.461 11.388 40.15c0 0 5.447 51.663-28.341 78.964l.122-71.128Z" />
        <path d="m155.541 169.837-25.84 21.77.174 18.57s-14.717 11.166-35.58 11.773l-30.523 6.437.002.799 91.81-7.15ZM153.68 221.863l-88.99 6.666 25.104 17.746 62.415-14.89Z" />
      </g>
      <path fill="currentColor" d="M283.814 289.333s-21.983 14.967-20.767 13.19c1.216-1.778 9.354-18.522 7.858-39.663" />
    </svg>
  );
}

export default function Pakt21Logo() {
  return (
    <span className="Pakt21Logo" aria-label="PAKT21">
      {Pakt21LogoMark()}
      <span className="Pakt21Logo-word">PAKT21</span>
    </span>
  );
}
